<template>
  <div class="member" style="background: #FAFAFC;min-width:1440px;">
    <div class="second_banner animated fadeIn" style="height:400px">
        <img :src=banners.url  class="banner_img"/>  
    </div>
    <div style="text-align:center;color:#2A303C;font-size:24px;margin-top:60px;margin-bottom:20px">{{title}}</div>
    <div style="text-align:center;color:#77818E;font-size:16px;margin-bottom:40px">{{conter}}</div>
    <div class="cent">
      <div class="member_content" @click="jub=false" style="display:flex;justify-content:center;align-items:center">
        <!-- <div style="width:80%">
          <img :src=item.url style="filter: blur(10px);" width=100% height=100%/>  
        </div> -->
        <div @click="linkTos" style="cursor:pointer;">
          <div class="el-icon-back cent"  style="background:#FFFFFF;border:1px solid #2E333A;width:40px;height:160px;color:#2E333A"></div>
        </div> 
        <div class="container" style="margin:0;">
          <div class="swiper" >
            <el-carousel arrow="never" ref="carousel"  indicator-position="none" :interval="3000" autoplay  type="card" height="399.58px" @change="go">
              <el-carousel-item  v-for="(item,index) in lists" :key="index"   :name="id" >
                  <!-- <div v-if="id==index" class="nei"> -->
                    <!-- <div class="top" style="font-weight:bold">{{item.title}}</div> -->
                    <!-- <div class="top">{{item.location}}</div>
                    <div class="top">{{item.author}}</div>
                    <div class="top">{{item.material}}</div>
                    <div class="top">{{item.size}}</div>
                    <div class="top">{{item.years}}</div> -->
                  <!-- </div> -->
                  <h3 v-if="id==index" class="medium" style="height:100%;">
                    <!-- <div style="z-index:100;position: fixed;line-height:53px;text-align:left;margin-left:30px">{{item.title}}</div> -->
                    <img :src=item.url width=100% height=100%/>
                  </h3>
                  <div v-if="id!=index">
                    <h3 class="medium" style="height:100%">
                      <img :src=item.url width=100% height=100%/>
                    </h3>
                  </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <!-- <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div class="item_top">
                  <h2>《移民者》</h2>
                  <span>波士顿雕塑家艺术馆</span>
                  <span>诺拉·瓦尔迪兹</span>
                  <span>印第安纳石灰岩</span>
                  <span>11 x 5 x 4英寸</span>
                  <span>2015年作品</span>
                </div>
                <div class="item_bottom">
                  <img src="../assets/img/works1.png" alt="" />
                </div>
              </div>
              <div class="swiper-slide">
                <div class="item_top">
                  <h2>《呼吸》</h2>
                  <span>波士顿雕塑家艺术馆</span>
                  <span>安迪·莫尔林恩</span>
                  <span>陶瓷</span>
                  <span>8 x 4 x 5 英寸</span>
                  <span>2016年作品</span>
                </div>
                <div class="item_bottom">
                  <img src="../assets/img/works2.png" alt="" />
                </div>
              </div>
              <div class="swiper-slide">
                <div class="item_top">
                  <h2>《微型塞丽娜II, 2016》</h2>
                  <span>卡罗尔•富尔曼雕塑基金会 ）</span>
                  <span>手工铸造，树脂材质镶嵌24K金箔</span>
                  <span>25.4 x 43.18 x 20.32 （单位：厘米</span>
                </div>
                <div class="item_bottom">
                  <img src="../assets/img/works3.png" alt="" />
                </div>
              </div>
              <div class="swiper-slide">
                <div class="item_top">
                  <h2>《数码网络》</h2>
                  <span>圣•乌尔班雕塑公园</span>
                  <span>海因茨·艾希里曼</span>
                  <span>不锈钢</span>
                  <span>3 x 35x 30厘米</span>
                  <span>3公斤</span>
                </div>
                <div class="item_bottom">
                  <img src="../assets/img/works4.png" alt="" />
                </div>
              </div>
              <div class="swiper-slide">
                <div class="item_top">
                  <h2>《作曲家XXIV》</h2>
                  <span>圣•乌尔班雕塑公园</span>
                  <span>海因茨·艾希里曼</span>
                  <span>不锈钢</span>
                  <span>40 x 35 x 25厘米</span>
                  <span>3kg</span>
                </div>
                <div class="item_bottom">
                  <img src="../assets/img/works5.png" alt="" />
                </div>
              </div>
            </div>
          </div> -->
        </div>
        <div @click="linkTo" style="cursor:pointer;">
          <div class="el-icon-right cent"  style="background:#FFFFFF;border:1px solid #2E333A;width:40px;height:160px;color:#2E333A"></div>
        </div> 
      </div>
    </div>
    <div class="works_list" @click="jub=false">
      <!-- <div class="works_listTop" v-if="chOrEn!='0'">全部作品</div>
      <div class="works_listTop" v-else> Art Works Show</div> -->
      <!-- <div class="weituimg">
        <img src="../assets/img/weitu.png"/>
      </div> -->
      <div class="font_ds" v-if="chOrEn!='0'">
        <!-- 雕塑是传承历史文化和彰显时代特征的重要载 -->
      </div>
      <div class="font_ds" v-else>
        <!-- Sculpture is an important carrier for inheriting history and culture and highlighting the characteristics of the times -->
      </div>
      <div class="works_List" >
        <div class="works_Listbox"  v-for="item in list" >
          <div class="boxleft" @click.stop="imgdfasdfes(item.url)">
            <img :src=item.url />
          </div>
          <div class="boxright" style="margin-right:20px">
            <div class="boxright2">{{item.title}}</div>
            <div class="boxright1 lefts">
              <img src="../assets/img/dingwei.png" style="margin-right:10px"/>
              {{item.location}}
            </div>
            <div class="boxright3">
              <i class="el-icon-user-solid" ><span style="padding-left:10px">{{item.author}}</span></i>
            </div>
            <div class="boxright4">{{item.size}}</div>
            <div class="boxright5">{{item.material}}</div>
            <!-- <div class="boxright6">{{item.years}}</div> -->
          </div>
        </div>
        <!-- <div class="works_Listbox">
          <div class="boxleft">
            <img src="../assets/img/works1.png"/>
          </div>
          <div class="boxright">
            <div class="boxright2">《呼吸》</div>
            <div class="boxright1">波士顿雕塑家艺术馆</div>
            <div class="boxright3">安迪·莫尔林恩</div>
            <div class="boxright4">陶瓷</div>
            <div class="boxright5">8x4x5英寸</div>
            <div class="boxright6">2016年作品</div>
          </div>
        </div>
        <div class="works_Listbox">
          <div class="boxleft">
            <img src="../assets/img/works1.png"/>
          </div>
          <div class="boxright">
            <div class="boxright2">《呼吸》</div>
            <div class="boxright1">波士顿雕塑家艺术馆</div>
            <div class="boxright3">安迪·莫尔林恩</div>
            <div class="boxright4">陶瓷</div>
            <div class="boxright5">8x4x5英寸</div>
            <div class="boxright6">2016年作品</div>
          </div>
        </div>
        <div class="works_Listbox">
          <div class="boxleft">
            <img src="../assets/img/works1.png"/>
          </div>
          <div class="boxright">
            <div class="boxright2">《呼吸》</div>
            <div class="boxright1">波士顿雕塑家艺术馆</div>
            <div class="boxright3">安迪·莫尔林恩</div>
            <div class="boxright4">陶瓷</div>
            <div class="boxright5">8x4x5英寸</div>
            <div class="boxright6">2016年作品</div>
          </div>
        </div> -->
      </div>
    </div>
    <div style="z-index:999" @click="jub=false">
      <div style="width: 40%;background: red;position: fixed;top: 10%;left: 30%;margin-top: -25px;margin-left: -25px;z-index:999" v-if="jub" >
        <img :src=it  width=100% height=100%/>
      </div>
    </div>
  </div>
</template>

<script>
// import Swiper from "swiper";
import { worksList,worksPage,bannerinfo } from '../api/api'
export default {
  name: "member",
  data() {
    return {
      chOrEn:sessionStorage.getItem('chOrEn'),
      mySwiper: "",
      list:[],
      lists:[],
      currentPage:1,
      id:0,
      it:"",
      jub:false,
      banners:"",
      title:'',
      conter:'',
    };
  },
  created(){
    this.button()
    let navigationId = {
      navigationId:6,
      chOrEn:1
    }
    //banner 
    bannerinfo({...navigationId}).then(res=>{
      this.banners = res.data.data[0]
      // debugger
      // this.banners.push(res.data.data[0])
      // this.banners.push(res.data.data[1])
      console.log(this.banners)
    })
  },
  mounted() {
    this.initSwiper();
  },
  methods: {
    linkTo () {
      if(this.$refs.carousel.activeIndex!=="3"){
        this.id=this.$refs.carousel.activeIndex+1
        let activeIndex = this.$refs.carousel.activeIndex+1
        // this.$router.push(this.lists[activeIndex])
        this.$refs.carousel.setActiveItem(this.id)
      }else{
        let activeIndex = 0
        this.id=0
        this.$router.push(this.lists[activeIndex])
        this.$refs.carousel.setActiveItem(this.id)
      }
    },
    linkTos () {
      if(this.$refs.carousel.activeIndex!=="0"){
        this.id=this.$refs.carousel.activeIndex-1
        // let activeIndex = this.$refs.carousel.activeIndex-1
        // this.$router.push(this.lists[activeIndex])
        this.$refs.carousel.setActiveItem(this.id)
      }else{
        let activeIndex = 3
        this.id=3
        // this.$router.push(this.lists[activeIndex])
        this.$refs.carousel.setActiveItem(this.id)
      }
    },
    imgdfasdfes(id){
      this.it=id
      this.jub=true
    },
    go(it){
      this.id=it
      this.title=this.lists[it].title
      this.conter=this.lists[it].location
      // debugger
    },
    button(){
      let navigationId = {
        page:this.currentPage,
        pageSize:10,
        isShow:1,
      }
      worksList({...navigationId}).then(res=>{
        this.list=[]
        this.list = res.data.data
      })
      let navigationIds = {
        page:this.currentPage,
        pageSize:10,
      }
      worksPage({...navigationIds}).then(res=>{
        this.lists=[]
        this.lists = res.data.page.rows
      })
    },
    initSwiper() {
      this.$nextTick(() => {
        this.mySwiper = new Swiper(".swiper-container", {
           slidesPerView: 3.5,
           direction : 'horizontal',
           loop: true,
           autoplay: 20000000000000, //可选选项，自动滑动
        });
      });
    },  
  },
};
</script>

<style lang="less" scoped>
.banner_img{
  height:400px
}
.cent{
  display: flex;
  justify-content: center;
  align-items: center;
}
.left{
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.lefts{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.nei{
  text-align:left;
  padding:40px;
  // height:40%;
  background:#FFFFFF;
  color:#333333
}
.top{
  padding-top:5px;
  font-size:21px;
}
.member_content {
  width: 100%;
  // height: 632px;
  // padding-top: 100px;
  // background: url("../assets/img/member_bg.png") no-repeat;
  background-size: 100% 100%;
  .container {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    flex-direction: column;
    color: rgba(255, 255, 255, 0.8);
    overflow: hidden;
    .swiper-container{
      // width: 100%;
      .swiper-slide {
        width: 383px;
        height: 404px;
        border-radius: 20px;
        margin-right: 50px;
        color: #222222;
        z-index: 0;
        transition: all 1s ease;
        // overflow: hidden;
        box-sizing: border-box;
        cursor: pointer;
        .item_top {
          width: 100%;
          height: 226px;
          background: #fff;
          padding-left: 55px;
          padding-top: 30px;
          text-align: left;
          border-top-right-radius: 20px;
          border-top-left-radius: 20px;
          h2 {
            font-size: 18px;
            line-height: 30px;
            font-weight: 800;
          }
          span {
            display: block;
            font-size: 14px;
            line-height: 30px;
          }
        }
        .item_bottom {
          width: 100%;
          height: 278px;
          overflow: hidden;
          border-bottom-right-radius: 20px;
          border-bottom-left-radius: 20px;
          img {
            width: 100%;
            height: 100%;
            transition: all 0.4s ease;
          }
          img:hover {
            width: 100%;
            height: 100%;
            transform: scale(1.2);
          }
        }
      }
      // .swiper-slide:hover{
      //   position: relative;
      //   z-index: 5;
      //   transform: translateZ(-50px);

      // }
      
    }
  }
}
.swiper{
  padding:0 20px;
  width: 100%;
  // height: 613px;
}
.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
  
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  .works_listTop{
    margin: 28px auto;
    text-align: center;
    color: #222222;
    font-weight: 700;
    font-size: 32px;
    line-height: 32px;
  }
  .weituimg img{
    width: 163px;
    height: 9px;
    margin: 0 auto;
  }
  .font_ds{
    text-align: center;
    color: #6C6C6C;
    font-size: 14px;
    padding-top: 8px;
    padding-bottom: 107px;
  }
  .works_List{
    width: 1206px;
    margin: auto;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
  }
  .works_List .works_Listbox{
    width: 580px;
    height: 300px;
    margin-bottom: 20px;
  }
  .works_List .works_Listbox .boxleft{
    display: inline-block;
  }
  .works_List .works_Listbox .boxright{
    display: inline-block;
  }
  .works_List div .boxleft{
    background: #A09999;
    height: 300px;
    width: 300px;
  }
  .works_List div .boxright{
    height: 300px;
    width: 280px;
    background: #FFFFFF;
    position: relative;
  }
  .boxleft img{
    width: 300px;
    height: 300px;
  }
  .boxright2{
    // position: absolute;
    width: 100%;
    font-size: 18px;
    color: #222222;
    padding-left: 24px;
    padding-top: 40px;
  }
  .works_Listbox{
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .boxright1{
    // position: absolute;
    font-size: 16px;
    color: #24367D;
    padding-left: 24px;
    padding-top: 25px;
  }
  .boxright6{
    // position: absolute;
    font-size: 14px;
    color: #222222;
    padding-left: 24px;
    // top: 248px;
    // bottom:0px
  }
  .boxright3{
    // position: absolute;
    font-size: 16px;
    color: #2A303C;
    padding-left: 24px;
    padding-top: 9px;
  }
  .boxright4{
    // position: absolute;
    font-size: 16px;
    color: #77818E;
    padding-left: 24px;
    padding-top: 12px;
  }
  .boxright5{
    // position: absolute;
    font-size: 14px;
    color: #77818E;
    padding-left: 24px;
    padding-top: 12px;
  }
</style>